import { useContext, useEffect } from 'react';

import { Box, Text } from '@chakra-ui/react';

import Card from 'components/card/Card';

import Message from 'components/fields/home/Message';

import { ApplicationFormContext } from 'contexts/ApplicationFormContext';

import { useAppSelector, useAppDispatch } from 'hooks';

import { removeRemark } from 'reducers/homePersonalFormReducer';

import { SECTIONS } from 'views/home_form/constants';

import UnderwritingHeader from './UnderwritingHeader';
import RiskAddress from './RiskAddress';
import RatingInformation from './RatingInformation';
import Mortgagee from './Mortgagee';
import Attachments from './Attachments';
import AddressHistory from './AddressHistory';
import LiabilityExposures from './LiabilityExposures';
import Coverages from './Coverages';
import LiabilityExtensionsExclusions from './LiabilityExtensionsExclusions';
import RatingInfoExtensions from './RatingInfoExtensions';
import DiscountsSurcharges from './DiscountsSurcharges';

const Dwellings = () => {
  const data = useAppSelector((state) => state.homePersonalForm.data.dwellings);
  const dispatch = useAppDispatch();

  const { validations } = useContext(ApplicationFormContext) as {
    validations: Validation[];
  };

  const validation503 = validations.find((v) => v.validation_id === '503');
  const messages503 =
    validation503?.validation_outcome_data?.messages_by_dwelling;

  useEffect(() => {
    if (!messages503) return;

    dispatch(removeRemark({ validation_key: '503', item_key: 'global' }));
  }, [dispatch, messages503]);

  if (!data) return null;

  return (
    <>
      {data.map((dwelling, index) => (
        <Card mb="20px" id="sectionDwellings">
          <Text fontWeight="bold" fontSize="2xl" mb="20px">
            Dwelling (Loc #{dwelling.loc_nr})
          </Text>

          <UnderwritingHeader dwelling={dwelling} index={index} />

          <RiskAddress dwelling={dwelling} index={index} />

          <Mortgagee dwelling={dwelling} index={index} />

          <Attachments dwelling={dwelling} index={index} />

          <AddressHistory dwelling={dwelling} index={index} />

          <LiabilityExposures dwelling={dwelling} index={index} />

          <LiabilityExtensionsExclusions dwelling={dwelling} index={index} />

          <RatingInfoExtensions dwelling={dwelling} index={index} />

          <RatingInformation dwelling={dwelling} index={index} />

          {messages503 && messages503[String(index + 1)] && (
            <Box mb="20px">
              <Message
                validationId="503"
                section={SECTIONS.DWELLINGS}
                storageKey="dwelling"
                index={index + 1}
                manual={{
                  show: true,
                  message: `(503) ${validation503?.validation_name} : ${
                    messages503[String(index + 1)]
                  }`,
                }}
              />
            </Box>
          )}

          <Coverages dwelling={dwelling} index={index} />

          <DiscountsSurcharges dwelling={dwelling} index={index} />
        </Card>
      ))}
    </>
  );
};

export default Dwellings;
